// RavePilotFooter — handoff v3.
//
// The handoff `.foot` is two-up: a copyright span on the left, a privacy
// reassurance on the right ("Your videos stay private until you submit
// them") — that one line does real work for the boomer audience. The
// previous version added Privacy/Terms links and used "RavePilot, Inc."; the
// handoff intentionally drops the links (this isn't a marketing page,
// it's a flow) and uses "RavePilot, LLC" (the actual legal entity).

export default function RavePilotFooter({ brand = null }) {
  const legal = (brand && (brand.legal_name || brand.name)) || 'RavePilot, LLC';
  return (
    <footer className="vt-foot">
      <span>© {legal}</span>
      <span>Your videos stay private until you submit them.</span>
    </footer>
  );
}
